import PropTypes from 'prop-types';

export const ChartPropTypes = PropTypes.shape({
  chartName: PropTypes.string.isRequired,
  originalChartName: PropTypes.string,
});

export const ChartMasterPropTypes = PropTypes.shape({
  fileName: PropTypes.string,
  importStatus: PropTypes.number,
  importResults: PropTypes.string,
  importFileRowCount: PropTypes.number,
  lineOfBusiness: PropTypes.string,
  businessCode: PropTypes.string,
  tpcGenerated: PropTypes.string,
  createdSSO: PropTypes.string,
  updatedSSO: PropTypes.string,
});

export const ChartAccountPropTypes = PropTypes.shape({
  localAccount: PropTypes.string.isRequired,
  localAccountDescription: PropTypes.string,
  r2rAccount: PropTypes.string,
  importStatusDetail: PropTypes.number,
  importValidation: PropTypes.string,
});

export const ChartAccountsPropTypes = PropTypes.arrayOf(ChartAccountPropTypes).isRequired;
